import request from "./../utils/request";

export function getWhatsappSS(channelId) {
    return request.get(channelId ? `/whatsapp/ss?channelId=${channelId}` : `/whatsapp/ss`);
}

const WHATSAPP_API = {
    BROADCAST: {
        getGroupById: (id) => request.get(`/whatsapp/broadcast/groups/${id}`),
        deleteGroupById: (id) => request.delete(`/whatsapp/broadcast/groups/${id}`),
        updateGroup: (id, name, description, contacts) =>
            request.post(`/whatsapp/broadcast/groups/${id}`, {
                id,
                name,
                description,
                contacts,
            }),
        listGroups: () => request.get(`/whatsapp/broadcast/groups`),
        createGroup: (name, contacts, userId, isBusiness) =>
            request.put(`/whatsapp/broadcast/groups`, { name, contacts, userId, isBusiness }),
        getAllBroadcastMessages: () => request.get(`/whatsapp/broadcast/messages`),
        listActiveBroadcastMessage: () => request.get(`/whatsapp/broadcast/messages/active`),
        listArchivedBroadcastMessage: () => request.get(`/whatsapp/broadcast/messages/archived`),
        listActiveBroadcastMessageLite: () => request.get(`/whatsapp/broadcast/messages/active/lite`),
        listArchivedBroadcastMessageLite: () => request.get(`/whatsapp/broadcast/messages/archived/lite`),
        getBroadcastMessageCountStats: () => request.get(`/whatsapp/broadcast/messages/stats`),
        getStatus: (ids) => request.post(`/whatsapp/broadcast/messages/status`, { ids }),
        getBroadcastMessageById: (id) => request.get(`/whatsapp/broadcast/messages/${id}`),
        updateBroadcastMessage: (id, updatingFields) =>
            request.post(`/whatsapp/broadcast/messages/${id}`, { updatingFields }),
        markArchiveBroadcastMessage: (id) =>
            request.post(`/whatsapp/broadcast/messages/${id}`, {
                updatingFields: {
                    archived: true,
                },
            }),
        createBroadcastMessage: (
            title,
            description,
            messages,
            all,
            groupId,
            excludePhoneNumbers,
            userId,
            scheduleAt,
            customPhoneNumbers,
            channel,
            selectedTemplate,
            templateParams
        ) =>
            request.put(`/whatsapp/broadcast/messages`, {
                title,
                description,
                messages,
                all,
                groupId,
                excludePhoneNumbers,
                userId,
                scheduleAt,
                customPhoneNumbers,
                channel,
                selectedTemplate,
                templateParams,
            }),
    },
    BUSINESS: {
        getTemplates: (channelId) => request.get(`/whatsapp/business/${channelId}/templates`),
        deleteTemplate: (channelId, templateName) => request.delete(`/whatsapp/business/${channelId}/${templateName}`),
    },
};
export default WHATSAPP_API;
